// removed by extract-text-webpack-plugin
module.exports = {"container":"_4N826","body":"_16tMR","carousel":"_2R0nD","slide":"_2cjpd","dots":"M2AXi","dot":"_2epsX","dot-active":"_13h51","navigation":"_2Py3s","next":"eX7YZ","previous":"_1G8Co","sr-only":"_3kmKs","sr-only-focusable":"_2_FCf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/Carousel.scss
// module id = ./src/components/Carousel/Carousel.scss
// module chunks = 0 2